import React from 'react';

const PropertyCategoryUpdateModal = ({
  isOpen,
  setIsOpen,
  inputValue,
  handleInputChange,
  handleAddAmenities,
}) => {
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">Add Property Category</h2>
        <form className="oms-modal-form" onSubmit={(e) => { e.preventDefault(); handleAddAmenities(); }}>

          {/* Category Name Input */}
          <div className="oms-form-group">
            <label htmlFor="categoryName" className="oms-form-label">Category Name</label>
            <input
              type="text"
              id="categoryName"
              name="categoryName"
              value={inputValue}
              onChange={handleInputChange}
              placeholder="Enter category name"
            />
          </div>

          {/* Actions */}
          <div className="oms-form-actions">
            <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
            <button type="submit">Submit</button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default PropertyCategoryUpdateModal;
